const renderProducts =async (shown,handlers,wrapper,maxToShow=4,textToExclude = false) => {
    // let valid = 0;
    // const promises = handlers.map((handler,index)=>{
    //     return fetch(`/products/${handler}?section_id=api-product-grid-item`)
    //         .then(response => response.text())
    //         .then(item => {
    //             if (!(textToExclude && textToExclude.length > 0 && (item.includes(textToExclude.toLowerCase()) || item.includes(textToExclude.toUpperCase())))) {
    //                 const aosDelay = index * 150;
    //                 const aosImageDuration =index * 100 + 800;
    //                 const aosTextDuration =index * 50 + 800;
    //                 const anchorAnimation = wrapper.id ? `#${wrapper.id}` : '';
    //                 const fresh = document.createElement('div');
    //                 let productReplaced = item.includes('||itemIndex||') ? item.replaceAll('||itemIndex||', index) : item;
    //                 productReplaced = productReplaced.includes('||itemAosDelay||') ? productReplaced.replaceAll('||itemAosDelay||', aosDelay) : productReplaced;
    //                 productReplaced = productReplaced.includes('||itemAosImageDuration||') ? productReplaced.replaceAll('||itemAosImageDuration||', aosImageDuration) : productReplaced;
    //                 productReplaced = productReplaced.includes('||itemAosTextDuration||') ? productReplaced.replaceAll('||itemAosTextDuration||', aosTextDuration) : productReplaced;
    //                 productReplaced = productReplaced.includes('||itemAnimationAnchor||') ? productReplaced.replaceAll('||itemAnimationAnchor||', anchorAnimation) : productReplaced;
    //                 fresh.setAttribute('data-product-handle',handlers[index])
    //                 fresh.innerHTML = productReplaced;

    //                 return fresh.querySelector('[data-api-content]').innerHTML;

    //                 wrapper.innerHTML += fresh.querySelector('[data-api-content]').innerHTML;
    //                 // handlers.shift();
    //                 // shown++;
    //                 // renderProducts(shown,handlers,wrapper,maxToShow,textToExclude)
    //             }
    //             else{
    //                 return false;
    //             }
    //         })
    //         .catch(e=>console.log(e))
    // })
    // Promise.allSettled(promises).then(productsHTML => {
    //     callBY != 'other' ? console.log(productsHTML) : null;
    //     productsHTML.map((productHTML,index) => {
    //         if(!productHTML.value) return
            
    //         if( valid <= maxToShow ){
    //             valid++;
    //             wrapper.innerHTML += productHTML.value
    //         } 
                
    //     })
    // });
    
    if(handlers.length && shown < maxToShow){
        fetch(`/products/${handlers[0]}?section_id=api-product-grid-item`)
            .then(response => response.text())
            .then(item => {
                if (textToExclude && textToExclude.length > 0 && (item.includes(textToExclude.toLowerCase()) || item.includes(textToExclude.toUpperCase()))) {
                    const soldOut = handlers.shift();
                    renderProducts(shown,handlers,wrapper,maxToShow,textToExclude)
                }
                else{
                    const aosDelay = shown * 150;
                    const aosImageDuration = shown * 100 + 800;
                    const aosTextDuration = shown * 50 + 800;
                    const anchorAnimation = wrapper.id ? `#${wrapper.id}` : '';
                    const fresh = document.createElement('div');
                    let productReplaced = item.includes('||itemIndex||') ? item.replaceAll('||itemIndex||', shown) : item;
                    productReplaced = productReplaced.includes('||itemAosDelay||') ? productReplaced.replaceAll('||itemAosDelay||', aosDelay) : productReplaced;
                    productReplaced = productReplaced.includes('||itemAosImageDuration||') ? productReplaced.replaceAll('||itemAosImageDuration||', aosImageDuration) : productReplaced;
                    productReplaced = productReplaced.includes('||itemAosTextDuration||') ? productReplaced.replaceAll('||itemAosTextDuration||', aosTextDuration) : productReplaced;
                    productReplaced = productReplaced.includes('||itemAnimationAnchor||') ? productReplaced.replaceAll('||itemAnimationAnchor||', anchorAnimation) : productReplaced;
                    fresh.setAttribute('data-product-handle',handlers[0])
                    fresh.innerHTML = productReplaced;

                    wrapper.innerHTML += fresh.querySelector('[data-api-content]').innerHTML;

                    handlers.shift();
                    shown++;
                    renderProducts(shown,handlers,wrapper,maxToShow,textToExclude)
                }
            })
            .catch(error=> Promise.reject(error))
    }
    else{
        if (shown === maxToShow)
            return Promise.resolve(true);
        else
            throw new Error('Not enough products');
    }
}